'use client'

import { useRef } from 'react'
import Image from 'next/image'
import type { HeroWithTagFragment } from '@/lib/types/datocms/graphql/generated'
import Eyebrow from '../ui/Eyebrow'
import ScrollDown from '../ui/ScrollDown'
import { TextWithHighlight } from '../TextWithHighlight'

export default function HeroWithTag({
	title,
	tag,
	image,
	backgroundVideo,
}: Readonly<HeroWithTagFragment>) {
	const ref = useRef<HTMLDivElement>(null)

	return (
		<section
			ref={ref}
			className="hero-with-tag relative bg-cover bg-center h-svh flex items-end after:content-[''] after:absolute after:inset-0 after:bg-gradient-to-t after:from-black/10 after:to-transparent before:content-[''] before:absolute before:inset-0 before:bg-black/30 @container before:z-10 after:z-10"
		>
			{image ? (
				<Image
					src={image[0].url}
					alt={image[0].alt}
					width={image[0].width}
					height={image[0].height}
					className="absolute inset-0 w-full h-full object-cover z-0"
					priority
				/>
			) : null}

			{backgroundVideo ? (
				<video
					className="object-cover h-full w-full absolute inset-0 z-0"
					width={backgroundVideo.video?.video?.width}
					height={backgroundVideo.video?.video?.height}
					playsInline
					src={backgroundVideo.video?.video?.mp4Url ?? ''}
					loop
					controls={false}
					autoPlay
					muted
				/>
			) : null}

			<div className="w-full max-w-screen-2xl mx-auto flex flex-col @5xl:flex-row gap-16 items-end px-3 py-6 @5xl:p-10 @5xl:justify-between">
				<div className="flex flex-col gap-4 @5xl:gap-8 w-full">
					{/* Eyebrow */}
					{tag ? <Eyebrow variant="secondary">{tag}</Eyebrow> : null}

					{/* Title */}
					{title ? (
						<h1 className="heading-hero text-white max-w-3xl @5xl:max-w-5xl z-10">
							<TextWithHighlight text={title} />
						</h1>
					) : null}
				</div>

				{/* Scroll down button */}
				<ScrollDown sectionRef={ref} variant="secondary" className="relative z-20">
					Discover more
				</ScrollDown>
			</div>
		</section>
	)
}
